export const STEP_KEY_SEPARATOR = ':'
export const MUTATION_ID_SEPARATOR = '/'

export enum HeaderModelIntentKeys {
  INTENT_ID = 'intent id',
  INTENT_NAME = 'intent name',
  INTENT_TYPE = 'intent type'
}

export enum HeaderModelExampleKeys {
  INTENT_ID = 'intent id',
  EXAMPLE_TEXT = 'example text'
}

export enum HeaderModelTriggerKeys {
  INTENT_ID = 'intent id',
  RULE_REGEX = 'rule regex',
  RULE_TYPE = 'rule type'
}

export enum HeaderModelVariableKeys {
  INTENT_ID = 'intent id',
  VARIABLE_NAME = 'variable name',
  VARIABLE_VALUE = 'variable value'
}

export enum HeaderMainKeys {
  STEP_ID = 'stepId',
  STEP_VALUE = 'value',
  STEP_TYPE = 'stepType',
  DIALOG_ID = 'dialogId',
  SUB_STEP_ID = 'subStepId',
  SUB_STEP_TYPE = 'subStepType'
}
